(function () {
  angular.module("akitabox.core.services.condition", [
    "akitabox.constants",
    "akitabox.core.services.http",
  ]);
})();
